import bootstrapGuestSession from './bootstrapGuestSession'

export default bootstrapGuestSession
